import { BsReply } from 'react-icons/bs';
import { MdDeleteOutline } from 'react-icons/md';
import type { StoryComment } from '~/common/types/story-comment';
import { routes } from '~/utils/routes';
import { Color } from '~/utils/styles/enums';
import {
  CommentItem,
  CommentItemProps,
} from '@app/(default-layout)/s/[storyId]/_components/comment-item';
import noImage from '@app/_assets/no-image.png';
import { Link } from '@app/_components/link';
import { VStack, Paragraph, HStack, Image, Box } from '@styled-system/jsx';
import likeFill from './assets/like-fill.svg';
import likeOutline from './assets/like-outline.svg';

type Props = {
  isOwner?: boolean;
  disableLike?: boolean;
  disableReply?: boolean;
  disableDelete?: boolean;
  onClickLike?: (comment: StoryComment) => void;
  onClickReply?: (comment: StoryComment) => void;
  onClickDelete?: (comment: StoryComment) => void;
} & CommentItemProps;

export const CommentItemWithAction = ({
  isOwner,
  disableLike,
  disableReply,
  disableDelete,
  onClickLike,
  onClickReply,
  onClickDelete,
  ...props
}: Props) => {
  const { author, comment } = props;

  return (
    <VStack w="100%" gap="3" alignItems="flex-start">
      <CommentItem {...props} pb="0" />
      {/* Like */}
      <HStack ml="70px" gap="8">
        {disableLike !== true && (
          <HStack alignItems="center" justify-content="center" gap="2">
            <Box onClick={() => onClickLike?.(comment)} cursor="pointer">
              <Image
                src={comment.likedByMe ? likeFill : likeOutline}
                alt="いいね"
              />
            </Box>
            {comment.likeCount > 0 && (
              <Paragraph pt="2px" fontSize="size_12" color="accent.700">
                {comment.likeCount}
              </Paragraph>
            )}

            {comment.likedByAuthor && author && (
              <Link href={routes.user.userDetail.url(comment.user.id)}>
                <Image
                  alt={author.name ?? 'ゲスト'}
                  src={author.thumbnailUrl ?? noImage}
                  w="20px"
                  h="20px"
                  borderRadius="50%"
                />
              </Link>
            )}
          </HStack>
        )}

        {disableReply !== true && (
          <HStack
            alignItems="center"
            cursor="pointer"
            gap="2"
            onClick={() => onClickReply?.(comment)}
          >
            <BsReply size="18px" color={Color.ACCENT_1000} />
            <Paragraph
              fontSize="size_12"
              lineHeight={1}
              mt="3px"
              color="accent.700"
            >
              返信
            </Paragraph>
          </HStack>
        )}

        {isOwner === true && disableDelete !== true && !comment.isDeleted && (
          <HStack
            alignItems="center"
            cursor="pointer"
            gap="2"
            onClick={() => onClickDelete?.(comment)}
          >
            <MdDeleteOutline size="18px" color={Color.ACCENT_1000} />
            <Paragraph
              fontSize="size_12"
              lineHeight={1}
              mt="3px"
              color="accent.700"
            >
              削除
            </Paragraph>
          </HStack>
        )}
      </HStack>
    </VStack>
  );
};
